export const SUPER_ADMIN_EMAILS = new Set([
    'srinivasan@helixops.ai'
]);

export const SUPER_ADMIN_EMAILS_DEV = new Set([
    'srinivasan@helixops.ai'
]);
